export default function getResource(label, vars = []) {
    const resources = {
        add: 'Ajouter',
        remove: 'Supprimer',
        addedText: 'Ajouté'
    };

    return resources[label];
}
